import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import moment from 'moment';
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import Close from "@material-ui/icons/Close";

import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Table from "../../components/Table/Table";
import Button from "../../components/CustomButtons/Button";

import style from "../../assets/jss/material-kit-pro-react/views/componentsSections/contentAreas";

import { unblockDate } from "../../actions/ownersActions";

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

class SectionBlockedDates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            noticeModal: false,
            dateToUnblock: {}
        };
    }

    handleToggle = value => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        this.setState({ checked: newChecked });
    };

    handleClickOpen = (modal, serviceType, serviceID, bookID, roomID, serviceName, roomName, start, end) => {
        let x = [];
        x[modal] = true;
        x['dateToUnblock'] = { serviceType, serviceID, bookID, roomID, serviceName, roomName, start, end };
        this.setState(x);
    };

    handleClose = modal => {
        let x = [];
        x[modal] = false;
        x['dateToUnblock'] = {};
        this.setState(x);
    };

    unblockDate = () => {
        const { dateToUnblock } = this.state;

        this.props.unblockDate(dateToUnblock);
        this.handleClose("noticeModal");
    };

    render() {
        const { blockedDates, classes } = this.props;

        const tableData = blockedDates.map(b => {
            return [
                b.type,
                <b>{`${b.serviceName}, ${!!b.roomName ? `(Habitación ${b.roomName})` : b.type === 'Alojamiento' ? '(Alojamiento Completo)' : ''}`}</b>,
                moment(b.start).format('DD/MM/YYYY'),
                moment(b.end).format('DD/MM/YYYY'),
                <Button color="danger" onClick={() => {
                    this.handleClickOpen("noticeModal", b.type, b.serviceID, b.bookID, !!b.roomID ? b.roomID : null, b.serviceName, b.roomName, b.start, b.end)}
                }>
                    Desbloquear fecha
                </Button>
            ];
        });

        return (
            <div className="cd-section" id="contentAreas">
                <div id="tables" style={{ marginBottom: '15px' }}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} lg={12} className={`${classes.mrAuto} ${classes.mlAuto}`}>
                            <h4>
                                <small>Fechas Bloqueadas</small>
                            </h4>

                            {/* NOTICE MODAL START */}
                            <Dialog
                                classes={{ root: classes.modalRoot, paper: classes.modal }}
                                open={this.state.noticeModal}
                                TransitionComponent={Transition}
                                keepMounted
                                onClose={() => this.handleClose("noticeModal")}
                                aria-labelledby="notice-modal-slide-title"
                                aria-describedby="notice-modal-slide-description"
                            >
                                <DialogTitle id="notice-modal-slide-title" disableTypography className={classes.modalHeader}>
                                    <Button
                                        simple
                                        className={classes.modalCloseButton}
                                        key="close"
                                        aria-label="Close"
                                        onClick={() => this.handleClose("noticeModal")}
                                    >
                                        {" "}
                                        <Close className={classes.modalClose} />
                                    </Button>
                                </DialogTitle>
                                <DialogContent id="notice-modal-slide-description" className={classes.modalBodyLittle}>
                                    <h4 className={classes.modalTitle}>
                                        ¿Seguro(a) que deseas desbloquear esta fecha?
                                    </h4>
                                </DialogContent>
                                <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
                                    <Button onClick={() => this.unblockDate()} color="danger">
                                        Si, desbloquear
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {/* NOTICE MODAL END */}

                            <Table
                                tableHead={['Tipo de Servicio', 'Nombre del Servicio', 'Inicio', 'Fin', 'Acciones']}
                                tableData={ tableData }
                                customCellClasses={[
                                    classes.textCenter,
                                    classes.textCenter
                                ]}
                                customClassesForCells={[0, 4]}
                                customHeadCellClasses={[
                                    classes.textCenter,
                                    classes.textCenter
                                ]}
                                customHeadClassesForCells={[0, 4]}
                            />
                        </GridItem>
                    </GridContainer>

                </div>
            </div>
        );
    }
}

SectionBlockedDates.propTypes = {
    unblockDate: PropTypes.func.isRequired,
    ownersReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    ownersReducer: state.ownersReducer,
    errors: state.errors
});

export default connect(mapStateToProps, { unblockDate })( withStyles(style)(SectionBlockedDates) );



// WEBPACK FOOTER //
// ./src/views/Management/SectionBlockedDates.jsx